import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { withCookies } from 'react-cookie';

import Footer from 'components/Footer';

import Home from 'pages/Home';
import Sweepstake from 'pages/Sweepstake';
import Winners from 'pages/Winners';

class App extends Component {
  render() {
    return (
      <main className="app">
        <Route path="/" exact component={Home} />
        <Route path="/sweepstake/:id" render={props => <Sweepstake cookies={this.props.cookies} {...props} />} />
        <Route path="/winners/:id" exact component={Winners} />
        <Footer />
      </main>
    );
  }
}

export default withCookies(App);
